var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"float-contact",attrs:{"href":"https://work.weixin.qq.com/kfid/kfcada7acc44b1348b6","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{attrs:{"src":_vm.kefuImg,"alt":"客服"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }